import { Logger } from './types';
import { err as serializeError } from 'pino-std-serializers';

function serializeMeta(meta: Record<string, unknown>): Record<string, unknown> {
  const serialized: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(meta)) {
    if (value instanceof Error) {
      serialized[key] = serializeError(value);
    } else {
      serialized[key] = value;
    }
  }

  return serialized;
}

class ConsoleLogger implements Logger {
  debug(message: string, meta: Record<string, unknown> = {}): void {
    console.debug({ message: message, ...serializeMeta(meta) });
  }
  info(message: string, meta: Record<string, unknown> = {}): void {
    console.info({ message: message, ...serializeMeta(meta) });
  }
  warn(message: string, meta: Record<string, unknown> = {}): void {
    console.warn({ message: message, ...serializeMeta(meta) });
  }
  error(message: string, meta: Record<string, unknown> = {}): void {
    console.error({ message: message, ...serializeMeta(meta) });
  }
}

/** This is a Logger that sends logs to other loggers */
class LogRouter implements Logger {
  private loggers: Logger[];
  protected boundMeta: Record<string, unknown> = {};

  /**
   *
   */
  constructor(boundMeta: Record<string, unknown> = {}) {
    this.loggers = [new ConsoleLogger()];
    this.boundMeta = boundMeta;
  }
  child(meta: Record<string, unknown> = {}): LogRouter {
    return new LogRouter({ ...this.boundMeta, ...meta });
  }
  debug(message: string, meta: Record<string, unknown> = {}) {
    this.loggers.map((logger) => logger.debug(message, { ...this.boundMeta, ...meta }));
  }
  info(message: string, meta: Record<string, unknown> = {}) {
    this.loggers.map((logger) => logger.info(message, { ...this.boundMeta, ...meta }));
  }
  warn(message: string, meta: Record<string, unknown> = {}) {
    this.loggers.map((logger) => logger.warn(message, { ...this.boundMeta, ...meta }));
  }
  error(message: string, meta: Record<string, unknown> = {}) {
    this.loggers.map((logger) => logger.error(message, { ...this.boundMeta, ...meta }));
  }
}
export const logger = new LogRouter();

export const createChildLogger = (meta: Record<string, unknown> = {}): LogRouter => {
  return logger.child(meta);
};
